import { Select, DatePicker } from "antd";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import tik from "../../../imgs/tik.png";
import axios from "axios";
import check from "../../../imgs/add.png";
import { useLocation } from "react-router";
import across from "../../../imgs/across.png";
import logo1 from "../../../imgs/logo12.png";
import moment from "moment";
import img from "../../../imgs/impLogo.png";
import { message } from "antd";
import { useEffect } from "react";
import { detectObjectsInImage } from "../../../utlis/modelLoader";
import FaceVerificatioNModal from "../../../utlis/FaceVerficationLoaderModal";
let file;
let ff = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolan",
  "Antiguans",
  "Argentinean",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Barbudans",
  "Batswana",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bhutanese",
  "Bolivian",
  "Bosnian",
  "Brazilian",
  "British",
  "Bruneian",
  "Bulgarian",
  "Burkinabe",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Cape Verdean",
  "Central African",
  "Chadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Comoran",
  "Congolese",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djibouti",
  "Dominican",
  "Dutch",
  "East Timorese",
  "Ecuadorean",
  "Egyptian",
  "Emirian",
  "Equatorial Guinean",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Fijian",
  "Filipino",
  "Finnish",
  "French",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Greek",
  "Grenadian",
  "Guatemalan",
  "Guinea-Bissauan",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Herzegovinian",
  "Honduran",
  "Hungarian",
  "I-Kiribati",
  "Icelander",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakhstani",
  "Kenyan",
  "Kittian and Nevisian",
  "Kuwaiti",
  "Kyrgyz",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Liechtensteiner",
  "Lithuanian",
  "Luxembourger",
  "Macedonian",
  "Malagasy",
  "Malawian",
  "Malaysian",
  "Maldivan",
  "Malian",
  "Maltese",
  "Marshallese",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Micronesian",
  "Moldovan",
  "Monacan",
  "Mongolian",
  "Moroccan",
  "Mosotho",
  "Motswana",
  "Mozambican",
  "Namibian",
  "Nauruan",
  "Nepalese",
  "New Zealander",
  "Nicaraguan",
  "Nigerian",
  "Nigerien",
  "North Korean",
  "Northern Irish",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palauan",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Polish",
  "Portuguese",
  "Qatari",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Lucian",
  "Salvadoran",
  "Samoan",
  "San Marinese",
  "Sao Tomean",
  "Saudi",
  "Scottish",
  "Senegalese",
  "Serbian",
  "Seychellois",
  "Sierra Leonean",
  "Singaporean",
  "Slovakian",
  "Slovenian",
  "Solomon Islander",
  "Somali",
  "South African",
  "South Korean",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Surinamer",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tongan",
  "Trinidadian or Tobagonian",
  "Tunisian",
  "Turkish",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbekistani",
  "Venezuelan",
  "Vietnamese",
  "Welsh",
  "Yemenite",
  "Zambian",
  "Zimbabwean",
];
let rr;
const Mid = () => {
  rr = ff.map((item) => {
    return {
      lable: `${item}`,
      value: `${item}`,
    };
  });

  useEffect(() => {
    dispatch({ type: "FACE_API", num: false });
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  }, []);
  const benId = useSelector((state) => state.benId);
  const dataUser = useSelector((state) => state.dataUser);
  const option = useSelector((state) => state.option);
  const icurrent = useSelector((state) => state.icurrent);
  const popData = useSelector((state) => state.popData);
  const faceApi = useSelector((state) => state.faceApi);
  const location = useLocation();
  const dash = location.pathname;
  const [age1, setAge1] = useState("");
  const [show, setShow] = useState(false);
  const [showC, setShowC] = useState(false);
  const [display, setDisplay] = useState(
    "data:image/png;base64,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"
  );
  const [title, setTitle] = useState("");
  const [msg, setMsg] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [buttonW, setButtonW] = useState("");
  const [buttonN, setButtonN] = useState(" Verify Again");
  const [pop, setPop] = useState("1");
  const [test, setTest] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [callName, setCallName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [ethnicity, setEthnicity] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [unionStatus, setUnionStatus] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("retired");
  const [nationality, setNationality] = useState("Guyanese");
  const [religion, setReligion] = useState("");
  const [homePhone, setHomePhone] = useState("");
  const [workPhone, setWorkPhone] = useState("");
  const [show1, setShow1] = useState(false);
  const [shows, setShows] = useState(false);
  const [err, setErr] = useState("");
  const [ss, setSs] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const [verify, setVerify] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [previousImage, setPreviousImage] = useState("");
  const [notHuman, setNotHuman] = useState(false);
  const [one, setOne] = useState(false);
  const [two, setTwo] = useState(false);
  const [three, setThree] = useState(false);
  const [four, setFour] = useState(false);
  const [five, setFive] = useState(false);
  const [ws, setWs] = useState("Permenantly Disability");
  const pensionerAdd = location?.state?.fromDashboard;
  const EmployeeAddBenficiary = location?.state?.fromEmployeeDashboard;
  const [ageError, setAgeError] = useState("");
  const fileInputRef = useRef(null);
  const FaceError = () => {
    messageApi.open({
      // type: 'success',
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="mage" width="50" height="50" />
          <h3>
            Please upload your profile image again; it's not verified as a human
            face.
          </h3>
        </div>
      ),
      duration: 6,
    });
  };

  const handleChange = (setState, check) => (event) => {
    console.log(shows,ws)
    if (check === "tt") {
      if (event) {
        // setAllow(false);
        const birthDate = event.$d;
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setAge1(age);
        if (age === 64) {
          const tod = today.getMonth() + 1;
          const earl = birthDate.getMonth() + 1;
          const fil = tod - earl;

          if (12 - fil <= 3) {
            // setAllow(true);
          }
        }
        let wow;
        if (event.$M <= 9) {
          if (event.$D <= 9) {
            wow = `${event.$y}-0${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-0${Number(event.$M) + 1}-${event.$D}`;
          }
        } else {
          if (event.$D <= 9) {
            wow = `${event.$y}-${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-${Number(event.$M) + 1}-${event.$D}`;
          }
        }
        setDob(wow);
      } else if (event === null) {
        setAge1("");
      }
    } else if (check === "tg") {
      setState(event);
    } else {
      setState(event.target.value);
    }
  };

  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const cryptoKey = await crypto.subtle.digest("SHA-256", buffer);
        const hashArray = Array.from(new Uint8Array(cryptoKey));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        resolve(hashHex);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const imageHandler = async (e) => {
    const file = e.target.files[0];
    const newImageHash = await calculateFileHash(file);

    if (newImageHash === previousImage && notHuman === true) {
      FaceError();
      fileInputRef.current.value = null;
      return;
    }

    if (file) {
      dispatch({ type: "FACE_API", num: true });
      const detectedObjects = await detectObjectsInImage(file);
      // setObjects(detectedObjects);

      const hasHuman = detectedObjects.some(
        (object) => object.class === "person"
      );
      dispatch({ type: "FACE_API", num: false });
      if (hasHuman) {
        setNotHuman(false);
        imageUploder(e);
        console.log("The image contains a human.");
      } else {
        setNotHuman(true);
        setPreviousImage(newImageHash);
        FaceError();
        console.log("The image does not contain a human.");
      }
      fileInputRef.current.value = null;
    }
  };

  const imageUploder = async (e) => {
    setIsLoading(true);
    file = e.target.files[0];
    const base641 = await convertToBase64(file);
    setDisplay(base641);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/v1/file/images?fileType=profile`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((data) => {
        setImageUrl(data.data.url);
        setIsLoading(false);
        setFive(false);
      })
      .catch(() => {});
  };
  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  useEffect(() => {
    if (!one && !two && !three && !four && !five) {
      setSs("");
    }
  }, [one, two, three, four, five]);
  const activeHandler = (setState, which, check) => {
    setSs(check);
    console.log("tester", check);
    if (!which) {
      setState(true);
    } else {
      setState(false);
    }
    setPop(check);
    if (check === "2" && !which) {
      setVerify(true);
      setMsg("Do you want to include the Medical Programe application too??");
      setButtonW("Yes");
      setButtonN("Cancel");
      setShowC(true);
    } else if (check === "3" && !which) {
      setVerify(true);
      setMsg(
        "Do you want to include the Economical Programe application too??"
      );
      setButtonW("Yes");
      setButtonN("Cancel");
      setShowC(true);
    } else if (check === "5" && !which) {
      setVerify(true);
      setMsg("Please provide details of your disability level");
      setButtonW("Temporary");
      setButtonN("Permanent");
      setShowC(true);
    }
  };
  const parityHandler = () => {
    const checkdob = new Date(dob);
    const currentDate = new Date();
    const yearsDiff = currentDate?.getFullYear() - checkdob.getFullYear();
    const monthsDiff = currentDate?.getMonth() - checkdob.getMonth();
    const daysDiff = currentDate?.getDate() - checkdob.getDate();
    if (
      yearsDiff > 64 ||
      (yearsDiff === 64 && monthsDiff > 9) ||
      (yearsDiff === 64 && monthsDiff === 9 && daysDiff >= 0)
    ) {
    } else {
      const targetYear = checkdob.getFullYear() + 64;
      const targetMonth = checkdob.getMonth() + 8;
      const targetDate = new Date(targetYear, targetMonth, checkdob.getDate());
      const timeDiff = targetDate.getTime() - currentDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      if (30 + daysDiff < 30) {
        setShow(true);
        setAgeError(
          `For Senior citizen pension program you should be or older than 65 years after ${
            30 + daysDiff
          } days you can register.`
        );
      } else {
        setShow(true);
        setAgeError(
          "For Senior citizen pension program you should be or older than 65 years"
        );
      }
    }
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  };
  const nextHandler = (e) => {
    e.preventDefault();
    let apiii;
    let body = {};
    body = {
      title,
      image: `${imageUrl}`,
      firstName,
      lastName,
      dateOfBirth: dob,
      gender,
      nationality,
    };
    if (religion) {
      body.religion = religion;
    }

    if (employmentStatus) {
      body.employmentStatus = employmentStatus;
    }
    if (unionStatus) {
      body.unionStatus = unionStatus;
    }
    if (ethnicity) {
      body.ethnicity = ethnicity;
    }
    if (middleName) {
      body.middleName = middleName;
    }
    if (callName) {
      body.callName = callName;
    }
    if (homePhone) {
      body.homePhone = homePhone;
    }
    if (workPhone) {
      body.workPhone = workPhone;
    }
    if (dash === "/superAdminDashboard/addAdmin")
      apiii = `/v1/persons/admin-person?personUserId=${popData.id}`;
    else if (dash === "/superAdminDashboard/addGroAdmin")
      apiii = `/v1/persons/gro-admin-person?personUserId=${popData.id}`;
    else if (dash === "/GroAdminDash/AddGroEmp")
      apiii = `/v1/persons/gro-employee-person?personUserId=${popData.id}`;
    if (
      dash === "/superAdminDashboard/addAdmin" ||
      dash === "/superAdminDashboard/addGroAdmin" ||
      dash === "/GroAdminDash/AddGroEmp"
    ) {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}${apiii}`,
          { person: body },
          {
            headers: {
              Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
            },
          }
        )
        .then((data) => {
          dispatch({ type: "IINCREMENT" });
          dispatch({ type: "data1Set", num: data });
          dispatch({
            type: "nameSet",
            num: `${data.data.firstName} ${data.data.lastName}`,
          });
          dispatch({
            type: "imageSet",
            num: `${data.data.image}`,
          });
        })
        .catch((err) => {
          if (
            err.response.data.message === '"image" is not allowed to be empty'
          ) {
            setErr("Please uplaod a profile picture");
          } else {
            setErr(err.response.data.message);
          }
          setShow1(true);
        });
    } else if (icurrent <= 5) {
      if (EmployeeAddBenficiary) {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/beneficiary/persons/add-by-staff?beneficiaryUserId=${benId}`,
            { person: body },
            {
              headers: {
                Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
              },
            }
          )
          .then(() => {
            dispatch({ type: "BRSET", num: 2 });
          })
          .catch((err) => {
            if (
              err.response.data.message === '"image" is not allowed to be empty'
            ) {
              setErr("Please uplaod a profile picture");
            } else {
              setErr(err.response.data.message);
            }
            setShow1(true);
          });
      } else if (option === "Employee") {
        axios
          .post(`${process.env.REACT_APP_BASE_URL}/v1/persons`, body, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((data) => {
            dispatch({ type: "IINCREMENT" });
            dispatch({ type: "data1Set", num: data });
            dispatch({
              type: "nameSet",
              num: `${data.data.firstName} ${data.data.lastName}`,
            });
            dispatch({
              type: "imageSet",
              num: `${data.data.image}`,
            });
          })
          .catch((err) => {
            if (
              err.response.data.message === '"image" is not allowed to be empty'
            ) {
              setErr("Please uplaod a profile picture");
            } else {
              setErr(err.response.data.message);
            }
            setShow1(true);
          });
      } else if (pensionerAdd) {
        axios

          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/beneficiary/persons?beneficiaryUserId=${benId}`,
            body,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            if (dash === "/Dashboard/BeneficiaryQuestions") {
              dispatch({ type: "BRSET", num: 2 });
            } else {
              dispatch({ type: "IINCREMENT" });
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === '"image" is not allowed to be empty'
            ) {
              setErr("Please uplaod a profile picture");
            } else {
              setErr(err.response.data.message);
            }
            setShow1(true);
          });
      } else {
        if (!one && !two && !three && !four && !five) {
          setErr("Please select one of the programs");
          setShow1(true);
        } else {
          if (dash === "/EDashboard/addPensioner") {
            axios
              .post(
                `${process.env.REACT_APP_BASE_URL}/v1/persons/add-by-staff?personUserId=${popData.id}`,
                { person: body },
                {
                  headers: {
                    Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
                  },
                }
              )
              .then((data) => {
                let body = [];
                body.push({
                  name: "senior-citizen-Pension",
                });
                dispatch({ type: "data1Set", num: data });
                dispatch({
                  type: "nameSet",
                  num: `${data.data.firstName} ${data.data.lastName}`,
                });
                dispatch({
                  type: "imageSet",
                  num: `${data.data.image}`,
                });
                axios
                  .post(
                    `${process.env.REACT_APP_BASE_URL}/v1/pension-programs/add-by-staff?programUserId=${popData.id}`,
                    { programs: body },
                    {
                      headers: {
                        Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
                      },
                    }
                  )
                  .then((data) => {
                    dispatch({ type: "setData", num: data.data });
                    dispatch({ type: "IINCREMENT" });
                  })
                  .catch((err) => {
                    setErr(err.response.data.message);
                    setShow1(true);
                  });
              })
              .catch((err) => {
                if (
                  err.response.data.message ===
                  '"image" is not allowed to be empty'
                ) {
                  setErr("Please uplaod a profile picture");
                } else {
                  setErr(err.response.data.message);
                }
                setShow1(true);
              });
          } else {
            axios
              .post(`${process.env.REACT_APP_BASE_URL}/v1/persons`, body, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((data) => {
                let body = [];

                body.push({
                  name: "senior-citizen-Pension",
                });

                dispatch({ type: "data1Set", num: data.data });
                dispatch({
                  type: "nameSet",
                  num: `${data.data.firstName} ${data.data.lastName}`,
                });
                dispatch({
                  type: "imageSet",
                  num: `${data.data.image}`,
                });
                axios
                  .post(
                    `${process.env.REACT_APP_BASE_URL}/v1/pension-programs`,
                    body,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  )
                  .then((data) => {
                    dispatch({ type: "setData", num: data.data });
                    dispatch({ type: "IINCREMENT" });
                  })
                  .catch((err) => {
                    setErr(err.response.data.message);
                    setShow1(true);
                  });
              })
              .catch((err) => {
                if (
                  err.response.data.message ===
                  '"image" is not allowed to be empty'
                ) {
                  setErr("Please uplaod a profile picture");
                } else {
                  setErr(err.response.data.message);
                }
                setShow1(true);
              });
          }
        }
      }
    } else {
      if (
        dash === "/EDashboard/BeneficiaryQuestions" ||
        dash === "/AdminDashboard/BeneficiaryQuestions" ||
        dash === "/superAdminDashboard/BeneficiaryQuestions"
      ) {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/beneficiary/persons/add-by-staff?beneficiaryUserId=${benId}`,
            { person: body },
            {
              headers: {
                Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
              },
            }
          )
          .then(() => {
            dispatch({ type: "BRSET", num: 2 });
          })
          .catch((err) => {
            if (
              err.response.data.message === '"image" is not allowed to be empty'
            ) {
              setErr("Please uplaod a profile picture");
            } else {
              setErr(err.response.data.message);
            }
            setShow1(true);
          });
      } else {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/beneficiary/persons?beneficiaryUserId=${benId}`,
            body,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            if (dash === "/Dashboard/BeneficiaryQuestions") {
              dispatch({ type: "BRSET", num: 2 });
            } else {
              dispatch({ type: "IINCREMENT" });
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === '"image" is not allowed to be empty'
            ) {
              setErr("Please uplaod a profile picture");
            } else {
              setErr(err.response.data.message);
            }
            setShow1(true);
          });
      }
    }
  };
  function getCurrentDate(separator = "") {
    let newDate = new Date();
    let date_raw = newDate.getDate();
    let month_raw = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    var date, month;

    if (date_raw < 10) {
      date = "0" + date_raw.toString();
    } else {
      date = date_raw.toString();
    }
    if (month_raw < 10) {
      month = "0" + month_raw.toString();
    } else {
      month = month_raw.toString();
    }
    return (
      <div>
        {year}
        {separator}
        {month}
        {separator}
        {date}
      </div>
    );
  }
  const date1 = getCurrentDate();
  const disabledBeforeDate1 = moment(
    `${date1.props.children[0]}-${date1.props.children[2]}-${date1.props.children[4]}`
  );
  const disabledDate1 = (current) => {
    return current && current > disabledBeforeDate1;
  };

  const Success = () => {
    messageApi.open({
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="Your Image" width="50" height="50" />
          <h3>This Module is under development and will be launched soon.</h3>
        </div>
      ),
      duration: 3,
    });
  };
  return (
    <div className={`${isLoading ? "pointer-events-none" : ""}`}>
      <form action="" onSubmit={nextHandler}>
        {contextHolder}
        <div className="flex items-center justify-center mb-4">
          <label htmlFor="special-input" className="cursor-pointer relative">
            <div className="relative w-[8.5rem] h-[8.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
              <img
                className="object-cover w-[8.5rem] h-[8.5rem]"
                src={display}
                alt=""
              />
            </div>

            <div
              className={`bg-primary rounded-full absolute bottom-4 right-2`}
            >
              <img src={check} className="lg:w-7 w-5" alt="" />
            </div>
            <input
              type="file"
              className="hidden"
              id="special-input"
              accept="image/png, image/gif, image/jpeg"
              // onInput={imageHandler}
              onChange={imageHandler}
              ref={fileInputRef}
            />
          </label>
        </div>
        <div className="flex justify-center items-center">
          <div className="grid sm:grid-cols-2 sm:gap-4 grid-cols-1 sm:w-[70%] w-[80%]">
            <div className="w-[100%]">
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Title
                </label>
                <Select
                  placeholder="Title"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.2rem" }}
                  onChange={handleChange(setTitle, "tg")}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  options={[
                    {
                      value: "Mr.",
                      label: "Mr.",
                    },
                    {
                      value: "Mrs.",
                      label: "Mrs.",
                    },
                    {
                      value: "Miss.",
                      label: "Miss.",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  First Name
                </label>
                <input
                  type="text"
                  name=""
                  onChange={handleChange(setFirstName)}
                  value={firstName}
                  placeholder="First Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Middle Name
                </label>
                <input
                  type="text"
                  name=""
                  onChange={handleChange(setMiddleName)}
                  value={middleName}
                  placeholder="Middle Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Last Name
                </label>
                <input
                  type="text"
                  name=""
                  onChange={handleChange(setLastName)}
                  value={lastName}
                  placeholder="Last Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  AKA / Call Name
                </label>
                <input
                  type="text"
                  name=""
                  onChange={handleChange(setCallName)}
                  value={callName}
                  placeholder="AKA / Call Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Date of Birth
                </label>
                <DatePicker
                  style={{ marginBottom: "1.2rem" }}
                  disabledDate={disabledDate1}
                  className="date-class"
                  onChange={handleChange(dob, "tt")}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Age
                </label>
                <input
                  style={{ marginBottom: "1.2rem" }}
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  value={`${age1 === "" ? "" : `${age1} year`}`}
                  onChange={(value) => {
                    if (one && value < 16) {
                      setErrorMessage("Age must be at least 16 years.");
                    } else {
                      setErrorMessage("");
                    }
                  }}
                  placeholder="Age"
                />
                {errorMessage}
              </div>
            </div>
            <div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Gender
                </label>
                <Select
                  placeholder="Gender"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.2rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setGender, "tg")}
                  options={[
                    {
                      value: "Male",
                      label: "Male",
                    },
                    {
                      value: "Female",
                      label: "Female",
                    },
                    {
                      value: "Non-Binary",
                      label: "Non-Binary",
                    },
                    {
                      value: "Transgender",
                      label: "Transgender",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Ethnicity
                </label>
                <Select
                  placeholder="Ethnicity"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.1rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setEthnicity, "tg")}
                  options={[
                    {
                      value: "African",
                      label: "African",
                    },
                    {
                      value: "Amerindian",
                      label: "Amerindian",
                    },
                    {
                      value: "Chinese",
                      label: "Chinese",
                    },
                    {
                      value: "East Indian",
                      label: "East Indian",
                    },
                    {
                      value: "European",
                      label: "European",
                    },
                    {
                      value: "Mixed Race",
                      label: "Mixed Race",
                    },
                    {
                      value: "Portuguese",
                      label: "Portuguese",
                    },
                    {
                      value: "Other",
                      label: "Other",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Marital Status
                </label>
                <Select
                  placeholder="Marital Status"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.1rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setUnionStatus, "tg")}
                  options={[
                    {
                      value: "common law",
                      label: "Common Law",
                    },
                    {
                      value: "divorced",
                      label: "Divorced",
                    },
                    {
                      value: "married",
                      label: "Married",
                    },
                    {
                      value: "separated",
                      label: "Separated",
                    },
                    {
                      value: "single",
                      label: "Single",
                    },
                    {
                      value: "visiting relation",
                      label: "Visiting Relation",
                    },
                    {
                      value: "widowed",
                      label: "Widowed",
                    },
                  ]}
                />
              </div>
              <div
                className={`${
                  option === "Employee" ? "hidden" : ""
                } flex flex-col`}
              >
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Employment Status
                </label>
                <Select
                  placeholder="Employment Status"
                  optionFilterProp="children"
                  className="wow"
                  value={employmentStatus}
                  style={{ marginBottom: "1rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setEmploymentStatus, "tg")}
                  options={[
                    {
                      value: "employed",
                      label: "Employed",
                    },
                    {
                      value: "retired",
                      label: "Retired",
                    },
                    {
                      value: "unemployed",
                      label: "Un-Employed",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Nationality
                </label>
                <Select
                  placeholder="Nationality"
                  showSearch
                  value={nationality}
                  className="wow"
                  onChange={handleChange(setNationality, "tg")}
                  optionFilterProp="children"
                  style={{
                    marginBottom: option === "Employee" ? "1rem" : "1.1rem",
                  }}
                  filterOption={(input, option) =>
                    (option?.lable ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  options={rr}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Religion
                </label>
                <Select
                  placeholder="Religion"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "0.9rem" }}
                  onChange={handleChange(setReligion, "tg")}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  showSearch
                  options={[
                    {
                      value: "Affrican Traditional Religions",
                      label: "Affrican Traditional Religions",
                    },
                    {
                      value: "Animism",
                      label: "Animism",
                    },
                    {
                      value: "Baha",
                      label: "Baha",
                    },
                    {
                      value: "Buddhism",
                      label: "Buddhism",
                    },
                    {
                      value: "Cao Dai",
                      label: "Cao Dai",
                    },
                    {
                      value: "Chinese traditional religion",
                      label: "Chinese traditional religion",
                    },
                    {
                      value: "Christianity",
                      label: "Christianity",
                    },
                    {
                      value: "Islam",
                      label: "Islam",
                    },
                    {
                      value: "Jainism",
                      label: "Jainism",
                    },
                    {
                      value: "Judaism",
                      label: "Judaism",
                    },
                    {
                      value: "Neo-Paganism",
                      label: "Neo-Paganism",
                    },
                    {
                      value: "Rastafari",
                      label: "Rastafari",
                    },
                    {
                      value: "Secular/Nonreligious/Agnostic/Atheist",
                      label: "Secular/Nonreligious/Agnostic/Atheist",
                    },
                    {
                      value: "Shinto",
                      label: "Shinto",
                    },
                    {
                      value: "Sikhism",
                      label: "Sikhism",
                    },
                    {
                      value: "Spiritism",
                      label: "Spiritism",
                    },
                    {
                      value: "Tenrikyo",
                      label: "Tenrikyo",
                    },
                    {
                      value: "Unitarian Universalism",
                      label: "Unitarian Universalism",
                    },
                    {
                      value: "Zoroastrianism",
                      label: "Zoroastrianism",
                    },
                    {
                      value: "Others",
                      label: "Others",
                    },
                  ]}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Other Contact Detail
                </label>
                <input
                  type="text"
                  // onChange={handleChange(setHomePhone)}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\+?[0-9()-]*$/.test(inputValue)) {
                      setHomePhone(inputValue);
                    }
                  }}
                  value={homePhone}
                  placeholder="Home Phone Number"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
                <input
                  type="text"
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\+?[0-9()-]*$/.test(inputValue)) {
                      setWorkPhone(inputValue);
                    }
                  }}
                  value={workPhone}
                  placeholder="Work Phone Number"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              {(pensionerAdd === false ||
                pensionerAdd === undefined ||
                EmployeeAddBenficiary === false ||
                EmployeeAddBenficiary === undefined) && (
                <div
                  className={`${
                    dash === "/Dashboard/BeneficiaryQuestions" ||
                    dash === "/superAdminDashboard/addAdmin" ||
                    icurrent >= 5 ||
                    option === "Employee"
                      ? "hidden"
                      : ""
                  }`}
                >
                  <h2 className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Programme
                  </h2>
                  <div className="w-full flex flex-wrap gap-x-2">
                    <div
                      onClick={() => {
                        parityHandler();
                        activeHandler(setOne, one, "1");
                      }}
                      className={` ${
                        one ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        one ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border  pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            one ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95] " src={tik} alt="" />
                        </div>
                        <p>Senior Citizen Pension - 65+ Years</p>
                      </div>
                    </div>

                    <div
                      onClick={Success}
                      className={` ${
                        two ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        two ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            two ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>PA-Economical</p>
                      </div>
                    </div>

                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>PA-Medical</p>
                      </div>
                    </div>
                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      } p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>Child Protection</p>
                      </div>
                    </div>
                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>Learning Lab</p>
                      </div>
                    </div>
                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>Palm Geriatric Home</p>
                      </div>
                    </div>
                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>PLWD</p>
                      </div>
                    </div>
                    <div
                      onClick={Success}
                      className={` ${
                        three ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        three ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl border pl-2 pr-2 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            three ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>Women Empowerment</p>
                      </div>
                    </div>

                    {/* <div className={`${shows ? "" : "hidden"}`}>
                    <div
                      onClick={Success}
                      className={` ${
                        four ? "bg-primary" : "bg-[#F7F7F7]"
                      } items-center ${
                        four ? "text-white" : "text-[#9CABC8]"
                      }  p-1 inline-block rounded-xl  pl-1 pr-1 mr-4 mb-2 cursor-pointer`}
                    >
                      <div className="flex items-center">
                        <div
                          className={`w-[22.8px] h-[22.8px] mr-1 ${
                            four ? "" : "hidden"
                          }`}
                        >
                          <img className="scale-[0.95]" src={tik} alt="" />
                        </div>
                        <p>{ws}</p>
                      </div>
                    </div>
                  </div>

                  <div
                    onClick={Success}
                    className={` ${
                      five ? "bg-primary" : "bg-[#F7F7F7]"
                    } items-center ${
                      five ? "text-white" : "text-[#9CABC8]"
                    }  p-1 inline-block rounded-xl  pl-1 pr-1 mr-4 mb-2 cursor-pointer`}
                  >
                    <div className="flex items-center">
                      <div
                        className={`w-[22.8px] h-[22.8px] mr-1 ${
                          five ? "" : "hidden"
                        }`}
                      >
                        <img className="scale-[0.95]" src={tik} alt="" />
                      </div>
                      <p>Disabled</p>
                    </div>
                  </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={`lg:mt-[3rem] flex mt-4 items-center sm:justify-end justify-center sm:w-[85%]`}
        >
          {/* <button
            type="button"
            onClick={() => dispatch({ type: "IDECREMENT" })}
            className={`lg:text-[1.1rem] bg-[#F2F4F8] text-black rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Back
          </button> */}

          <button
            type="button"
            onClick={() => {
              if (
                (one ||
                  option !== "Pensioner" ||
                  option === "Employee" ||
                  dash === "/Dashboard/BeneficiaryQuestions" ||
                  dash === "/EDashboard/BeneficiaryQuestions" ||
                  dash === "/AdminDashboard/BeneficiaryQuestions" ||
                  dash === "/superAdminDashboard/BeneficiaryQuestions" ||
                  (dash === "/" && icurrent === 11)) &&
                title &&
                imageUrl &&
                firstName &&
                lastName &&
                dob &&
                gender &&
                nationality
              ) {
                if (option === "Employee" && age1 < 16) {
                  setErr("Employee must be a minimum of 16 years of age");
                  setShow1(true);
                } else if (
                  option === "Employee" &&
                  age1 < 16 &&
                  (dash === "/GroAdminDash/AddGroEmp" ||
                    dash === "/superAdminDashboard/addGroAdmin")
                ) {
                  setErr("GRO must be a minimum of 16 years of age");
                  setShow1(true);
                } else if (
                  (icurrent > 5 || icurrent === 1) &&
                  age1 < 18 &&
                  dash !== "/superAdminDashboard/addGroAdmin" &&
                  dash !== "/GroAdminDash/AddGroEmp" &&
                  dash !== "/superAdminDashboard/addAdmin"
                ) {
                  setErr("Beneficiary must be a minimum of 18 years of age");
                  setShow1(true);
                } else {
                  setMsg(
                    "Please verify that all the details provided are correct. Once submitted you cannot change any information"
                  );

                  setButtonN("Verify Again");
                  setButtonW("Submit");
                  setVerify(true);
                  setShowC(false);
                  setPop("1");
                }
              } else {
                if (
                  !one &&
                  dash !== "/EDashboard/BeneficiaryQuestions" &&
                  dash !== "/AdminDashboard/BeneficiaryQuestions" &&
                  dash !== "/superAdminDashboard/BeneficiaryQuestions" &&
                  dash !== "/Dashboard/BeneficiaryQuestions" &&
                  option === "Pensioner" &&
                  icurrent < 4
                ) {
                  setErr("Program is not selected");
                } else if (option === "Employee" && 16 > parseInt(age1)) {
                  setErr("Employee must be a minimum of 16 years of age");
                } else if (!title) {
                  setErr("Title is not selected");
                } else if (!imageUrl) {
                  setErr("Image is not selected");
                } else if (!firstName) {
                  setErr("First Name is not entered");
                } else if (!lastName) {
                  setErr("Last Name is not entered");
                } else if (!dob) {
                  setErr("Date of Birth is not entered");
                } else if (!gender) {
                  setErr("Gender is not selected");
                } else if (!nationality) {
                  setErr("Nationality is not selected");
                }

                setShow1(true);
              }
            }}
            // onClick={() => dispatch({ type: "IINCREMENT" })}
            className={`lg:text-[1.1rem] bg-gradient-to-tr ml-4 bg-primary text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Next
          </button>
        </div>
        <div
          className={`${
            verify ? "" : "hidden"
          } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
        >
          <div className="relative rounded-xl w-[25rem] pb-6 pt-4 flex items-center p-3 bg-white flex-col">
            <div>
              <img src={logo1} alt="" className="w-20 h-20"/>
            </div>
            <p className="text-center mt-[1rem] mb-5">{msg}</p>
            <div className="flex">
              <button
                type="button"
                onClick={() => {
                  setVerify(false);
                  if (ss === "5") {
                    setWs("Permanent Disability");
                    setFour(true);
                  }
                }}
                className="cursor-pointer mr-2 rounded-xl pt-[0.5rem] pb-[0.5rem] pl-5 pr-5 text-white bg-[#DE2827]"
              >
                {buttonN}
              </button>

              <button
                type="submit"
                onClick={() => setVerify(false)}
                className={`${
                  pop === "1" ? "" : "hidden"
                } cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-8 pr-8 text-white bg-primary`}
              >
                Submit
              </button>
              <button
                type="button"
                onClick={() => {
                  setVerify(false);
                  if (ss === "2") {
                    setThree(true);
                  } else if (ss === "3") {
                    setTwo(true);
                  } else if (ss === "5") {
                    setWs("Temporary Disability");
                    setShows(true);
                    setFour(true);
                  }
                }}
                className={`${
                  pop === "1" ? "hidden" : ""
                } cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-8 pr-8 text-white bg-primary`}
              >
                {buttonW}
              </button>
            </div>
            <div
              className={`${
                showC ? "" : "hidden"
              } bottom-[-30%] absolute flex items-center p-2 bg-white rounded-2xl`}
            >
              <img className="w-[1.8rem] mr-1" src={logo1} alt="" />
              <p className="font-semibold">Coming Soon</p>
            </div>
          </div>
        </div>
      </form>
      <div
        className={`${
          show ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => {
              setOne(false);
              setShow(false);
            }}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">
            {ageError}
            {/* For old age pension program you should be or older than 65 years. */}
          </p>
          <button
            onClick={() => {
              setOne(false);
              setShow(false);
            }}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          show1 ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow1(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            onClick={() => setShow1(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      {faceApi === true && <FaceVerificatioNModal />}
    </div>
  );
};

export default Mid;
